import {Component, OnInit, signal} from '@angular/core';
import {PpeService} from '../services/ppe.service';
import {PpeEquipment} from '../ppe-equipment';
import {Router, RouterLink} from '@angular/router';
import {CodaltComponent} from '../codalt.component';
import {Routenames} from '../route-names.enum';
import {ConfirmDialogService} from '../services/confirm-dialog-service/confirm-dialog.service';
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatIconButton} from "@angular/material/button";

@Component({
    selector: 'app-ppe-management',
    templateUrl: './ppe-management.component.html',
    styleUrls: ['./ppe-management.component.scss'],
    imports: [
        VvrIconComponent,
        RouterLink,
        MatTooltip,
        MatIconButton
    ]
})
export class PpeManagementComponent extends CodaltComponent implements OnInit {

    readonly equipments = signal<PpeEquipment[]>([]);
    readonly currentSort = signal<string>(null);
    readonly desc = signal<boolean>(false);

    constructor(
        private ppeService: PpeService,
        private confirmDialog: ConfirmDialogService,
        private router: Router
    ) {
        super();
    }

    ngOnInit(): void {
        this.ppeService.listEquipment().subscribe(equipment => {
            this.equipments.set(equipment.data);
        });
    }

    edit(equipment: PpeEquipment) {
        this.router.navigate([Routenames.ppeEquipment, equipment.id]);
    }

    sortList(sortingOn) {
        let decorations = this.equipments();
        this.equipments.set([]);

        if (sortingOn === this.currentSort()) {
            decorations = decorations.reverse();
            this.desc.set(!this.desc());
        } else {
            this.desc.set(false);
            decorations = decorations.sort((a, b) => {
                if (a[sortingOn].toUpperCase() < b[sortingOn].toUpperCase()) {
                    return -1;
                }
                if (a[sortingOn].toUpperCase() > b[sortingOn].toUpperCase()) {
                    return 1;
                }
                return 0;
            });
        }

        this.equipments.set(decorations);

        this.currentSort.set(sortingOn);
    }

    delete(event, equipment: PpeEquipment) {
        event.stopPropagation();
        this.confirmDialog.confirm(
            'Aanvraag intrekken',
            `Weet u zeker dat u PBM ${equipment.name} wilt verwijderen?`,
            'Verwijderen',
            'Behouden'
        ).then(() => {
            this.ppeService.deleteEquipment(equipment.id).subscribe(() => {
                const index = this.equipments().indexOf(equipment);
                this.equipments().splice(index, 1);
            });
        }, () => {

        });
    }

}
